// extracted by mini-css-extract-plugin
module.exports = {"root":"Socials_root__bZp54","social":"Socials_social__LRWBF","title":"Socials_title__nvnYt","wrapper":"Socials_wrapper__MuIIN","list":"Socials_list__qVPnQ"};